export const ServizioOptions = [
	{
		label: "",
		value: undefined
	},
	{
		label: "Consegna",
		value: "Consegna"
	},
	{
		label: "Reso",
		value: "Reso"
	},
	{
		label: "Posa",
		value: "Posa"
	}
]

export const MotivoOptionsConsegna = [
	{
		label: "",
		value: undefined
	},
	{
		label: 'Annullamento/Modifica',
		value: 'CONS_ANN'
	},
	{
		label: 'Informazioni stato consegna', 
		value: 'CONS_STATINFO'
	},
	{
		label: 'Problema in consegna', 
		value: 'CONS_PROB'
	},
	{
		label: 'Reclamo consegna',
		value: 'CONS_RECL'
	},
	{
		label: 'Richiesta informazioni consegna', 
		value: 'CONS_RICHINFO' 
	},
	{
		label: 'Segnalazione danno consegna', 
		value: 'CONS_DANN'
	}
]

export const MotivoOptionsReso = [
	{
		label: "",
		value: undefined
	},
	{
	    label: 'Annullamento/Modifica', 
	    value: 'RES_ANN'
	},
	{
		label: 'Informazioni stato reso',
		value: 'RES_STATRES'
	},
	{
		label: 'Segnalazione danno reso', 
		value: 'RES_DANN' 
	},
	{
		label: 'Reclamo reso', 
		value: 'RES_RECL'
	},
	{
		label: 'Richiesta informazioni reso', 
		value: 'RES_RICHINFO'
	}

]

export const MotivoOptionsPosa = [
	{
		label: "",
		value: undefined
	},
	{
		label: "Altro",
		value: "Altro"
	},
	{
	    label: 'Annullamento/Modifica', 
	    value: 'POS_ANN'
	    },
	{
	    label: 'Informazioni stato posa', 
		value: 'POS_STATPOS'
	},
	{
	    label: 'Reclamo posa', 
	    value: 'POS_RECL' 
	}   ,
	{
		label: 'Richiesta informazioni posa', 
		value: 'POS_RICHINFO' 
	},
	{
		label: 'Segnalazione danno posa', 
		value: 'POS_DANN'
	}
]
